import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Defer sitemap sync to avoid blocking TTI
if (!sessionStorage.getItem("sitemap-synced")) {
  // Use requestIdleCallback or setTimeout to defer
  const syncSitemap = () => {
    import("./lib/sync-news-sitemap").then(({ syncNewsSitemap }) => {
      syncNewsSitemap().then(() => {
        sessionStorage.setItem("sitemap-synced", "1");
      });
    });
  };

  if ("requestIdleCallback" in window) {
    (window as any).requestIdleCallback(syncSitemap);
  } else {
    setTimeout(syncSitemap, 3000);
  }
}
